export default __webpack_public_path__ + "static/media/certificate_first.1ad3b733.jpg";